import { render, staticRenderFns } from "./Paginate.vue?vue&type=template&id=b8df85a6&scoped=true&"
import script from "./Paginate.vue?vue&type=script&lang=js&"
export * from "./Paginate.vue?vue&type=script&lang=js&"
import style0 from "./Paginate.vue?vue&type=style&index=0&id=b8df85a6&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8df85a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8df85a6')) {
      api.createRecord('b8df85a6', component.options)
    } else {
      api.reload('b8df85a6', component.options)
    }
    module.hot.accept("./Paginate.vue?vue&type=template&id=b8df85a6&scoped=true&", function () {
      api.rerender('b8df85a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2wVzP1w2Dp2uC/JS/comp/Paginate.vue"
export default component.exports